import { type GoalAttributes } from './generated/GoalAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import ColorAttribute, {
  type IColorAttribute,
} from './concerns/ColorAttribute';

interface Goal extends GoalAttributes, IColorAttribute {}

@model
@ColorAttribute()
class Goal extends ApplicationModel {
  // Start auto-generated
  static typename: 'Goal' = 'Goal';
  get typename(): 'Goal' {
    return 'Goal';
  }

  static internalTypename: 'StrategicImperative' = 'StrategicImperative';
  get internalTypename(): 'StrategicImperative' {
    return 'StrategicImperative';
  }

  static terminologyName = 'Goal';

  static inputType = 'GoalAttributes!';

  static filterType = 'GoalFilters!';
  static filters = { id: '[ID!]', projectId: 'ID' };

  static fields = {
    childrenCount: attr({ readable: true }),
    color: attr({ readable: true }),
    commentsCount: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    drillInUrl: attr({
      args: {
        publishableId: 'ID',
        publishableType: 'String',
        viewSnapshotId: 'ID',
        dashboardId: 'ID',
        exportType: 'String',
        bookmarkId: 'ID',
      },
      readable: true,
    }),
    epicsCount: attr({ readable: true }),
    featuresCount: attr({ readable: true }),
    id: attr({ readable: true }),
    initiativesCount: attr({ readable: true }),
    keyResultsCount: attr({ readable: true }),
    metricName: attr({ readable: true }),
    name: attr({ writable: true, readable: true }),
    parentId: attr({ readable: true }),
    path: attr({ readable: true }),
    projectId: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    releasesCount: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    workflowStatusId: attr({ readable: true }),
    createdByUser: attr.belongsTo({ readable: true, typename: 'User' }),
    epoch: attr.belongsTo({ readable: true, typename: 'Epoch' }),
    parent: attr.belongsTo({ readable: true, typename: 'Goal' }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    project: attr.belongsTo({
      writeShape: ['id'],
      readable: true,
      typename: 'Project',
    }),
    screenDefinition: attr.belongsTo({
      readable: true,
      typename: 'ScreenDefinition',
    }),
    successMetric: attr.belongsTo({ writeShape: ['name'], readable: false }),
    terminology: attr.belongsTo({
      readable: true,
      typename: 'TerminologyItem',
    }),
    workflowStatus: attr.belongsTo({
      writeShape: ['id', 'name', 'category'],
      readable: true,
      typename: 'WorkflowStatus',
    }),
    childRecordLinks: attr.hasMany({
      args: { filters: 'RecordLinkFilters' },
      readable: true,
    }),
    children: attr.hasMany({ readable: true }),
    comments: attr.hasMany({ readable: true }),
    customFieldValues: attr.hasMany({
      args: { ids: '[ID!]', keys: '[String!]' },
      readable: true,
    }),
    epics: attr.hasMany({ readable: true }),
    features: attr.hasMany({ readable: true }),
    initiatives: attr.hasMany({ readable: true }),
    keyResults: attr.hasMany({ readable: true }),
    parentRecordLinks: attr.hasMany({
      args: { filters: 'RecordLinkFilters' },
      readable: true,
    }),
    releases: attr.hasMany({ readable: true }),
    tasks: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default Goal;
